import { Box, Input, InputGroup, InputLeftAddon } from "@chakra-ui/react";
import moment from "moment";
import React, { Component } from "react";
import { GoDiffRenamed } from "react-icons/go";
import { Puff, ThreeDots } from "react-loading-icons";
import GridTable from "../../../lib/GridTable";
import {
  runVerificaAutenticacao,
  ListaTelasCRM,
  LayoutPendentes,
  AtualizaProcessoLayout,
} from "../../../services/api";
import Header from "../../../components/Header";
import {
  LayoutContainerFilter,
  LayoutContainerFilterControl,
  LayoutContainerFilterControlTables,
  LayoutContainerText,
  ModalLayoutContainer,
  ModalLayoutContainerContent,
  ModalLayoutContainerContentDataGrid,
  ModalLayoutContainerContentDataGridProduct,
  ModalLayoutContainerContentDataGridProductField,
  ModalLayoutContainerContentDataGridProductRow,
  ModalLayoutContainerContentDataGridProductRowNoneBorder,
  ModalLayoutContainerContentDataGridProductRowOrange,
  ModalLayoutContainerContentFilter,
  ModalLayoutContainerContentHeader,
} from "./styles";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      pedidos: [],
      numero_pedido: null,
      loading: false,
      loading_confirmar: false,
      codigo_usuario: JSON.parse(localStorage.getItem("authentication"))
        .codigo_usuario,
      codigo_vendedor: JSON.parse(localStorage.getItem("authentication"))
        .codigo_vendedor,

      control_inclusao: null,
      control_alteracao: null,
      control_exclusao: null,
      control_consulta: null,
    };
  }

  componentDidMount() {
    runVerificaAutenticacao();
    this.initial();
  }

  initial = async () => {
    await this.CarregaPermissoes();
    this.getLessons();
  };

  CarregaPermissoes = async () => {
    try {
      const response = await ListaTelasCRM.get(
        "/" + window.location.pathname.replace("/", "")
      );
      var data = response.data;

      var codigo_tela = null;
      for (var obj in data) {
        codigo_tela = obj;
      }

      this.setState({
        codigo_tela: codigo_tela,
        control_inclusao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].inclusao,
        control_alteracao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].alteracao,
        control_exclusao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].exclusao,
        control_consulta: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].consulta,
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getLessons = async () => {
    if (this.state.control_consulta != "S") {
      alert("Permissão negada");
      return false;
    }
    this.setState({ data: [], pedidos: [] });
    var numero_pedido = "";
    if (ifnull(this.state.numero_pedido, "") != "") {
      numero_pedido = this.state.numero_pedido;
    }

    try {
      const response = await LayoutPendentes.get(numero_pedido);
      var data = response.data;

      var itens = [];
      var pedidos = [];
      var data_pedidos = [];
      data.map((item) => {
        if (!pedidos.includes(item.numero_pedido)) {
          pedidos.push(item.numero_pedido);
          data_pedidos.push(item);
          // item.data_inicio = null;
        }
      });

      this.setState({ data: data, pedidos: data_pedidos });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  changeFilter = async (e, value) => {
    this.setState({ [value]: e.target.value });
  };

  changeField = async (e, value) => {
    var value_field = e.target.value;
    var objitem = JSON.parse(e.target.attributes.data.value);

    this.state.data.map((item) => {
      if (
        item.numero_pedido.trim() == objitem.numero_pedido.trim() &&
        item.codigo_produto == objitem.codigo_produto &&
        item.sequencia == objitem.sequencia
      ) {
        item[value] = value_field;
      }
    });

    this.setState({ uptade: true });
  };

  UpdateProcess = async (e, option = 1) => {
    if (!window.parseint(data.codigo_status).includes([3, 9])) {
      var checked = eval(e.target.value);
      var data = JSON.parse(e.target.attributes.data.value);
      this.setState({ loading_confirmar: true });
      if (!checked) {
        try {
          if (option == 1) {
            var param = {
              data_inicio: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
              link_layout: "",
              numero_nota: data.numero_nota,
              numero_pedido: data.numero_pedido,
              codigo_produto: data.codigo_produto,
              sequencia: data.sequencia,
            };
          } else {
            var param = {
              data_inicio: "",
              link_layout: "",
              codigo_status: 2,
              numero_nota: data.numero_nota,
              numero_pedido: data.numero_pedido,
              codigo_produto: data.codigo_produto,
              sequencia: data.sequencia,
            };
          }

          const response = await AtualizaProcessoLayout.post("", param);
          var data = response.data;

          if (data.status) {
            await this.setState({ loading_confirmar: false });
            this.setState({ data: [], pedidos: [] });
            await this.getLessons();
          } else {
            alert("O processo não pode ser iniciado.");
            await this.setState({ loading_confirmar: false });
            this.setState({ data: [], pedidos: [] });
            await this.getLessons();
          }
        } catch (error) {
          this.setState({ loading_confirmar: false });
          alert("O processo não pode ser iniciado.");
          console.log(Object.keys(error), error.message);
        }
      }
    }
  };

  EndsProcess = async (e) => {
    if (!window.parseint(data.codigo_status).includes([3, 9])) {
      var data = JSON.parse(e.target.attributes.data.value);
      this.setState({ loading_confirmar: true });
      try {
        var count = 0;
        data.map(async (item, idx) => {
          if (item.numero_pedido == this.state.data_modal.numero_pedido) {
            count++;
          }
        });

        var idx = 0;
        data.map(async (item) => {
          if (item.numero_pedido == this.state.data_modal.numero_pedido) {
            idx++;
            var param = {
              data_inicio: "",
              link_layout: item.link_layout,
              numero_nota: item.numero_nota,
              numero_pedido: item.numero_pedido,
              codigo_produto: item.codigo_produto,
              sequencia: item.sequencia,
            };

            const response = await AtualizaProcessoLayout.post("", param);
            var result = response.data;

            if (count == idx) {
              if (result.status) {
                await this.setState({ loading_confirmar: false });
                this.setModalView(null, false);
                this.setState({ data: [], pedidos: [] });
                await this.getLessons();
              } else {
                this.setState({ loading_confirmar: false });
                alert("O processo não pode atualizar todos os produtos.");
                this.getLessons();
              }
            }
          }
        });
      } catch (error) {
        this.setState({ loading_confirmar: false });
        console.log(Object.keys(error), error.message);
      }
    }
  };

  setModalView = async (e, value) => {
    if (e != null) {
      var data = JSON.parse(e);
      await this.setState({
        data_modal: {
          numero_pedido: data.numero_pedido,
          status: data.codigo_status,
        },
      });

    }

    this.setState({ view_modal: value });
    if (!value) {
      this.setState({ data: [], list_data: [] });
      this.getLessons();
    }
  };

  cancelLayout = async (numero_pedido) => {
    if (window.confirm("Você deseja cancelar este layout?")) {
      try {
        var count = 0;
        this.state.data.map(async (item, idx) => {
          if (item.numero_pedido == numero_pedido) {
            count++;
          }
        });

        var idx = 0;
        this.state.data.map(async (item) => {
          if (item.numero_pedido == numero_pedido) {
            idx++;
            var param = {
              data_inicio: "",
              link_layout: "",
              codigo_status: 9,
              numero_nota: item.numero_nota,
              numero_pedido: item.numero_pedido,
              codigo_produto: item.codigo_produto,
              sequencia: item.sequencia,
            };

            const response = await AtualizaProcessoLayout.post("", param);
            var result = response.data;

            if (count == idx) {
              if (result.status) {
                await this.setState({ loading_confirmar: false });
                this.setModalView(null, false);
                this.setState({ data: [], pedidos: [] });
                await this.getLessons();
              } else {
                this.setState({ loading_confirmar: false });
                alert("O processo não pode atualizar todos os produtos.");
                this.getLessons();
              }
            }
          }
        });
      } catch (error) {
        this.setState({ loading_confirmar: false });
        alert("O processo não pode ser iniciado.");
        console.log(Object.keys(error), error.message);
      }
    }
  };

  render() {
    const { dados, pedidos } = this.state;

    function checkFormatter(cell, formatExtraData, exec_function, data) {
      return (
        <div>
          <GoDiffRenamed
            fontSize={20}
            data={data}
            onClick={() => exec_function(data)}
          />
        </div>
      );
    }

    function cancelCell(cell, formatExtraData, exec_function, data) {
      return (
        <button
          style={{
            width: "20px",
            border: "none",
            borderRadius: "3px",
            backgroundColor: "#ff7e00",
            fontFamily: "Akrobat",
            color: "white",
            cursor: "pointer",
            fontWeight: "500",
          }}
          data={cell}
          onClick={() => exec_function(cell)}
        >
          X
        </button>
      );
    }

    function dataFormatter(value) {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    }

    function statusFormatter(cell, formatExtraData) {
      return formatExtraData[cell];
    }

    function priceFormatter(value) {
      var atual = value
        ? parseFloat(value).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        : "";
      return atual;
    }

    const columns = [
      {
        dataField: "numero_pedido",
        text: "Abrir itens",
        formatter: checkFormatter,
        formatExtraData: [],
        exec_function: (e) => this.setModalView(e, true),
        sort: true,
      },
      {
        dataField: "codigo_status",
        text: "Status",
        formatter: statusFormatter,
        formatExtraData: {
          0: "PENDENTE",
          1: "EM EXECUÇÃO",
          2: "AGUARDANDO VENDEDOR",
          3: "FINALIZADO",
          9: "CANCELADO",
        },
      },
      {
        dataField: "numero_pedido",
        text: "Numero do pedido",
        sort: true,
      },
      {
        dataField: "vendedor",
        text: "Vendedor",
      },
      {
        dataField: "prazo_entrega",
        text: "Prazo",
        sort: true,
      },
      {
        dataField: "observacao",
        text: "Observação",
        sort: true,
      },
      {
        dataField: "data_solicitacao",
        text: "Data da solicitação",
        formatter: dataFormatter,
        sort: true,
      },
      {
        dataField: "numero_pedido",
        text: "Cancelar",
        formatter: cancelCell,
        formatExtraData: [],
        exec_function: (e) => this.cancelLayout(e),
        sort: true,
      },
    ];

    return (
      <>
        <LayoutContainerText>
          <h1>
            <strong>LAYOUT</strong>
          </h1>
        </LayoutContainerText>
        <Box bgColor="#F4F5F5">
          {this.state.view_modal ? (
            <Modal
              closeModalLayout={() => this.setModalView(null, false)}
              data_modal={this.state.data}
              numero_pedido={this.state.data_modal.numero_pedido}
              status={this.state.data_modal.status}
              UpdateProcess={this.UpdateProcess}
              EndsProcess={this.EndsProcess}
              changeField={this.changeField}
              loading={this.state.loading}
              loading_confirmar={this.state.loading_confirmar}
            />
          ) : (
            <></>
          )}

          <LayoutContainerFilter>
            <LayoutContainerFilterControl>
              <InputGroup fontFamily="Akrobat" size="sm">
                <InputLeftAddon
                  bgColor="#D85959"
                  color="white"
                  children="Nº PEDIDO:"
                />
                <Input
                  w="200px"
                  focusBorderColor="#D85959"
                  bgColor="white"
                  autoFocus
                  placeholder="Digite o número..."
                  type="text"
                  onChange={(e) => this.changeFilter(e, "numero_pedido")}
                />
              </InputGroup>
              <button onClick={() => this.getLessons()}>Filtrar</button>
            </LayoutContainerFilterControl>
            {pedidos.length == 0 ? (
              <h1>Nenhuma solicitação de layout encontrada.</h1>
            ) : (
              <></>
            )}
          </LayoutContainerFilter>

          <LayoutContainerFilterControlTables>
            {pedidos.length > 0 ? (
              <GridTable columns={columns} dados={pedidos} />
            ) : (
              <></>
            )}
          </LayoutContainerFilterControlTables>
        </Box>
      </>
    );
  }
}

function Modal(data) {
  return (
    <ModalLayoutContainer>
      <ModalLayoutContainerContent>
        <ModalLayoutContainerContentHeader>
          <p>ITENS PARA GERAÇÃO DE LAYOUT - Nº PEDIDO: {data.numero_pedido}</p>
          <span onClick={() => data.closeModalLayout()}>Fechar</span>
        </ModalLayoutContainerContentHeader>
        <ModalLayoutContainerContentDataGrid>
          {data.data_modal.map((item) => {
            if (item.numero_pedido == data.numero_pedido) {
              return (
                <ModalLayoutContainerContentDataGridProduct>
                  <ModalLayoutContainerContentDataGridProductRowOrange>
                    <h1>
                      Código do produto: <strong>{item.codigo_produto}</strong>
                    </h1>
                  </ModalLayoutContainerContentDataGridProductRowOrange>
                  <ModalLayoutContainerContentDataGridProductRow>
                    <p>
                      Cor: <strong>{item.cor}</strong>
                    </p>
                    <p>
                      Impressão: <strong>{item.tipo_impressao}</strong>
                    </p>
                    <p>
                      Batidas: <strong>{item.batida}</strong>
                    </p>
                    <p>
                      Link Logo:{" "}
                      <a href={item.link_logo} target="__blank">
                        Acessar
                      </a>
                    </p>
                  </ModalLayoutContainerContentDataGridProductRow>
                  <ModalLayoutContainerContentDataGridProductRowNoneBorder>
                    <ModalLayoutContainerContentDataGridProductField>
                      <label>Inicio de execução:</label>
                      {data.loading_confirmar ? (
                        <Puff stoke="#98ff98" />
                      ) : (
                        <input
                          data={JSON.stringify(item)}
                          type="radio"
                          checked={
                            ifnull(item.data_inicio, "") != "" ? true : false
                          }
                          value={
                            ifnull(item.data_inicio, "") != "" ? true : false
                          }
                          onClick={(e) => data.UpdateProcess(e, 1)}
                        />
                      )}
                      <label>Aguardando vendedor:</label>
                      {data.loading_confirmar ? (
                        <Puff stoke="#98ff98" />
                      ) : (
                        <input
                          data={JSON.stringify(item)}
                          type="radio"
                          checked={
                            parseInt(item.codigo_status) == 2 ? true : false
                          }
                          value={
                            parseInt(item.codigo_status) == 2 ? true : false
                          }
                          onClick={(e) => data.UpdateProcess(e, 2)}
                        />
                      )}
                    </ModalLayoutContainerContentDataGridProductField>
                  </ModalLayoutContainerContentDataGridProductRowNoneBorder>
                  <ModalLayoutContainerContentDataGridProductRowNoneBorder>
                    <ModalLayoutContainerContentDataGridProductField>
                      <label>Link Layout</label>
                      <input
                        type="text"
                        data={JSON.stringify(item)}
                        onChange={(e) => data.changeField(e, "link_layout")}
                      />
                      {item.link_layout != "" ? (
                        <a href={item.link_layout} target="__blank">
                          Layout Anterior
                        </a>
                      ) : (
                        <></>
                      )}
                    </ModalLayoutContainerContentDataGridProductField>
                  </ModalLayoutContainerContentDataGridProductRowNoneBorder>
                </ModalLayoutContainerContentDataGridProduct>
              );
            }
          })}
        </ModalLayoutContainerContentDataGrid>
        <ModalLayoutContainerContentFilter>
          {data.loading_confirmar ? (
            <button>
              <ThreeDots />
            </button>
          ) : (
            <button
              disabled={data.status == 3 || data.status == 9 ? true : false}
              data={JSON.stringify(data.data_modal)}
              style={
                data.status == 3 || data.status == 9 ? { opacity: "0.7" } : {}
              }
              onClick={(e) => data.EndsProcess(e)}
            >
              Finalizar Layout
            </button>
          )}
        </ModalLayoutContainerContentFilter>
      </ModalLayoutContainerContent>
    </ModalLayoutContainer>
  );
}

function ifnull(a, b) {
  if (a == "" || a == undefined || a == null) {
    return b;
  } else {
    return a;
  }
}

function sleep(milliseconds) {
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if (new Date().getTime() - start > milliseconds) {
      break;
    }
  }
}

export default Layout;
